<template>
  <v-form ref="formStepPricing" v-model="formStepPricingValid" @submit.prevent="submit">
    <v-row>
      <v-col cols="12">
        <v-card class="rounded-xl mt-4 d-flex-column" :border="false" :elevation="0">
          <v-row>
            <v-col cols="12">
              <h1>{{ $t('FILE_STEP_PRICING.TITLE') }}</h1>
            </v-col>

            <!--UNDER GUARANTEE MESSAGE-->
            <v-col cols="12" v-if="isInGuarantee()">
              {{ $t('FILE_STEP_PRICING.UNDER_GUARANTEE') }}
            </v-col>

            <v-col cols="12" v-if="!isInGuarantee() && packageInfo">
              <v-radio-group v-model="packageType" hide-details>
                <v-row class="d-flex justify-center">
                  <!--PACKAGE CARD-->
                  <v-col cols="6" class="d-flex" v-if="packageInfo.package_type !== 'ESTIMATE'">
                    <v-card
                      :class="{ active: packageType === 'PACKAGE' }"
                      :elevation="0"
                      class="package-info rounded-xl flex-fill"
                      @click="packageType = 'PACKAGE'"
                    >
                      <v-radio value="PACKAGE" />
                      <p class="card-title">
                        {{
                          $t('FILE_STEP_PRICING.PACKAGE_INFO.PACKAGE') +
                          ' ' +
                          packageInfo.network_code
                        }}
                      </p>
                      <p class="card-sub-title">
                        {{ getTotalAmount() }} {{ $t('COMMON.EURO') }} {{ $t('COMMON.EXCLUSIVE_TAX')}}
                      </p>
                      <div class="w-100 d-flex justify-space-between align-left">
                        <p class="font-weight-bold">
                          {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.REPAIR_TIME') }}
                        </p>
                        <p v-if="currentRepairFile?.product_repair_time">
                          {{
                            currentRepairFile?.product_repair_time +
                            ' ' +
                            $t('FILE_STEP_PRICING.PACKAGE_INFO.DAYS')
                          }}
                        </p>
                      </div>
                      <div class="w-100 d-flex justify-space-between align-left">
                        <p class="font-weight-bold">
                          {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.REPAIR_COST') }}
                        </p>
                        <p>
                          {{
                            (packageInfo.client_price ? packageInfo.client_price / 100 : 0).toFixed(
                              2
                            ) +
                            ' ' +
                            $t('COMMON.EURO')
                          }}
                        </p>
                      </div>
                      <div class="w-100 d-flex justify-space-between align-left">
                        <p class="font-weight-bold">
                          {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.TRANSPORT_COST') }}
                        </p>
                        <p>
                          {{
                            (transportInfo ? transportInfo.transport_cost / 100 : 0).toFixed(2) +
                            ' ' +
                            $t('COMMON.EURO')
                          }}
                        </p>
                      </div>
                      <div class="w-100 d-flex justify-space-between align-left">
                        <p class="font-weight-bold">
                          {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.ADDITIONAL_COST') }}
                        </p>
                        <p>{{ additional_repair_cost.toFixed(2) + ' ' + $t('COMMON.EURO') }}</p>
                      </div>
                      <div class="w-100 d-flex justify-space-between align-left">
                        <p class="font-weight-bold">
                          {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.REPAIR_FUND') }}
                        </p>
                        <p>
                          {{
                            currentRepairFile?.product_amount_repair_fund
                              ? currentRepairFile?.product_amount_repair_fund.toFixed(2)
                              : 0 + ' ' + $t('COMMON.EURO')
                          }}
                        </p>
                      </div>
                      <div v-if="showNewPrice()" class="w-100 d-flex justify-space-between">
                        <p class="font-weight-bold">
                          {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.PRODUCT_NEW_PRICE') }}
                        </p>
                        <p>
                          {{
                            currentRepairFile?.product_new_price.toFixed(2) +
                            ' ' +
                            $t('COMMON.EURO')
                          }}
                        </p>
                      </div>
                      <div class="w-100 d-flex mt-6 justify-space-around">
                        <div class="send-estimate-package">
                          <img
                            class="mr-2 mb-1"
                            :class="packageType !== 'PACKAGE' ? 'send-black-svg' : 'send-white-svg'"
                            alt="send-icon"
                            src="@/assets/icons/file/send.svg"
                          />
                          <p @click="openModal('estimatePackageModal')">
                            {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.ESTIMATE_PACKAGE') }}
                          </p>
                        </div>
                      </div>
                    </v-card>
                  </v-col>

                  <!--ESTIMATE CARD-->
                  <v-col
                    v-if="
                      packageInfo.package_type === 'ESTIMATE' ||
                      (packageInfo.package_type !== 'ESTIMATE' &&
                        packageInfo.display_estimate === 'active')
                    "
                    class="d-flex"
                    cols="6"
                  >
                    <v-card
                      :class="{ active: packageType === 'ESTIMATE' }"
                      :elevation="0"
                      class="package-info rounded-xl flex-fill"
                      @click="packageType = 'ESTIMATE'"
                    >
                      <v-radio value="ESTIMATE" />
                      <p class="card-title">{{ $t('FILE_STEP_PRICING.PACKAGE_INFO.ESTIMATE') }}</p>
                      <p class="card-sub-title">-</p>
                      <div class="w-100 d-flex justify-space-between align-left">
                        <p class="font-weight-bold">
                          {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.REPAIR_TIME') }}
                        </p>
                        <p>{{ 28 + ' ' + $t('FILE_STEP_PRICING.PACKAGE_INFO.DAYS') }}</p>
                      </div>

                      <!--Diag message-->
                      <div class="w-100 d-flex justify-space-between align-left">
                        <p class="font-weight-bold">
                          {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.REPAIR_AMOUNT') }}
                        </p>
                        <p>{{ $t('FILE_STEP_PRICING.PACKAGE_INFO.WITH_DIAGNOSTIC') }}</p>
                      </div>

                      <!--Transport cost for estimate-->
                      <div
                        v-if="estimate_transporter_cost !== 0"
                        class="w-100 d-flex justify-space-between align-left"
                      >
                        <p class="font-weight-bold">
                          {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.ESTIMATE_TRANSPORT_COST') }}
                        </p>
                        <p>{{ estimate_transporter_cost.toFixed(2) }} €</p>
                      </div>

                      <!--Diag cost-->
                      <div class="w-100 d-flex justify-space-between align-left">
                        <p class="font-weight-bold">
                          {{ $t('FILE_STEP_PRICING.PACKAGE_INFO.DIAGNOSTIC_COST') }}
                        </p>
                        <p>45.00 €</p>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-col>

            <!--Pricing Code-->
            <v-col cols="12" lg="6">
              <div class="customer-text">
                <p>
                  {{ $t('FILE_STEP_PRICING.CUSTOMER_CODE') }}
                  <v-tooltip location="left bottom">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" icon="mdi-information-outline" color="#54981b" />
                    </template>
                    <div class="tooltip-content">
                      <strong>{{ $t('FILE_STEP_PRICING.TOOLTIP.S_1') }}</strong>
                      {{ $t('FILE_STEP_PRICING.TOOLTIP.T_1') }} <br /><br />
                      <strong>{{ $t('FILE_STEP_PRICING.TOOLTIP.S_2') }}</strong>
                      {{ $t('FILE_STEP_PRICING.TOOLTIP.T_2') }} <br /><br />
                      <strong>{{ $t('FILE_STEP_PRICING.TOOLTIP.S_3') }}</strong>
                      {{ $t('FILE_STEP_PRICING.TOOLTIP.T_3') }}
                    </div>
                  </v-tooltip>
                </p>
              </div>

              <v-text-field
                class="customer-code"
                v-model.trim="customer_code"
                :placeholder="$t('FILE_STEP_PRICING.PLACEHOLDER.CUSTOMER_CODE')"
                v-on:input="resetError('customer_code')"
                :error-messages="error?.customer_code"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col>
        <v-btn
          :disabled="!formStepPricingValid || (!packageType && !isInGuarantee()) || loading"
          :loading="loading"
          class="pl-15 pr-15"
          :class="
            !formStepPricingValid || (!packageType && !isInGuarantee()) || loading
              ? 'boom-button-transparent'
              : 'boom-button'
          "
          type="submit"
          variant="outlined"
        >
          {{ $t('COMMON.BUTTON.CONTINUE') }}
          <img
            alt="arrow_small-icon"
            :class="
              !formStepPricingValid || (!packageType && !isInGuarantee()) || loading
                ? 'arrow-black-svg'
                : 'arrow-white-svg'
            "
            src="@/assets/icons/file/arrow_small_right.svg"
          />
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
  <EstimatePackageModal ref="estimatePackageModal" />
</template>

<script>
import AdditionalRepairCostService from '@/services/AdditionalRepairCostService'
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import ResponseConstant from '@/constants/responseConstant'
import { auth as $store } from '@/store/AuthModule'
import RepairFileService from '@/services/RepairFileService'
import PackageService from '@/services/PackageService'
import TransportPackageService from '@/services/TransportPackageService'
import RepairFileGuaranteeConstant from '@/constants/repairFileGuaranteeConstant'
import EstimatePackageModal from '@/components/modal/repair-file/EstimatePackageModal.vue'
import { RepairFile } from '@/models/RepairFile'
import RepairFilePricingTypeConstant from '@/constants/repairFilePricingTypeConstant'
import EstimateTransporterCostService from '@/services/repairModule/repairFile/EstimateTransporterCostService'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'

export default {
  name: 'StepPricingPage',
  components: { EstimatePackageModal },
  props: {
    currentStep: Number,
    currentRepairFile: {
      type: RepairFile,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      formStepPricingValid: false,
      awaitingSearch: null,
      customer_code: null,
      additional_repair_cost: 0,
      estimate_transporter_cost: 0,
      packageInfo: null,
      packageType: null,
      transportInfo: null,
      error: null
    }
  },
  watch: {
    customer_code() {
      this.loading = true
      if (this.customer_code && this.customer_code.length) {
        if (this.awaitingSearch) {
          clearTimeout(this.awaitingSearch)
        }
        this.awaitingSearch = setTimeout(async () => {
          await this.getAdditionalRepairCost()
          this.awaitingSearch = null
        }, 1000)
      } else {
        if (this.awaitingSearch) {
          clearTimeout(this.awaitingSearch)
        }
      }
      this.loading = false
    }
  },
  async mounted() {
    this.customer_code = this.currentRepairFile?.initial_customer_code || ''
    this.packageType = this.currentRepairFile?.initial_pricing_type

    await this.getAdditionalRepairCost(this.customer_code)
    await this.getEstimateTransporterCost()
  },
  methods: {
    isInGuarantee() {
      return this.currentRepairFile.status_guarantee !== RepairFileGuaranteeConstant.NOT_GUARANTEE
    },
    async getAdditionalRepairCost() {
      try {
        let realCode = 'C'
        if (this.customer_code !== null || this.customer_code !== '') {
          realCode = this.customer_code.toUpperCase()
        }

        const response = await AdditionalRepairCostService.getAdditionalRepairCostByCustomerCode(
          realCode
        )
        this.additional_repair_cost = response.additional_cost
      } catch (error) {
        this.additional_repair_cost = 0
        this.packageInfo = {
          package_type: 'ESTIMATE'
        }
      }
      if (!this.isInGuarantee()) {
        await this.getTransportCost()
      }
    },
    async getEstimateTransporterCost() {
      try {
        const response = await EstimateTransporterCostService.getEstimateTransporterCost(
          this.currentRepairFile.technical_id
        )
        this.estimate_transporter_cost = response.cost
      } catch (error) {
        this.estimate_transporter_cost = 0
      }
    },
    async getPackageInfo() {
      try {
        this.packageInfo = await PackageService.getPackage(this.currentRepairFile?.boomerang_id)
      } catch (error) {
        this.packageInfo = {
          package_type: 'ESTIMATE'
        }
      }
    },
    async getTransportCost() {
      try {
        this.transportInfo = await TransportPackageService.getTransportPackage(
          this.currentRepairFile?.boomerang_id
        )
        await this.getPackageInfo()
      } catch (error) {
        if (
          error.response?.data &&
          error.response.data.key === 'transport_package_not_found_error_key'
        ) {
          displayToast(this.$t('ERROR.TRANSPORT_PACKAGE_NOT_FOUND_ERROR_KEY'), 'warning')
        } else {
          handleResponseError(error)
        }
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          this.setError(error.response.data.key)
        }
        await this.getPackageInfo()
      }
    },
    getTotalAmount() {
      const transportCost = this.transportInfo ? this.transportInfo?.transport_cost / 100 : 0
      const amountRepairFund = this.currentRepairFile?.product_amount_repair_fund
        ? this.currentRepairFile?.product_amount_repair_fund
        : 0
      const totalAmount =
        this.packageInfo.client_price / 100 +
        this.additional_repair_cost +
        transportCost -
        amountRepairFund
      return totalAmount.toFixed(2)
    },
    async updatePartialData() {
      if (!this.isInGuarantee() && !this.packageInfo) {
        return
      }

      let realCode = 'C'
      if (this.customer_code !== null || this.customer_code !== '') {
        realCode = this.customer_code.toUpperCase()
      }

      const formattedData = {
        status_detail: RepairFileStatusDetailConstant.PRICING_SENT_TO_CUSTOMER,
        customer_code: realCode,
        requestor_collaborator_id: $store.state.currentCollaborator.technical_id
      }

      if (!this.isInGuarantee()) {
        if (this.packageType) {
          formattedData['pricing_type'] = this.packageType

          if (this.packageType === RepairFilePricingTypeConstant.PACKAGE) {
            formattedData['package_boomerang_id'] = this.packageInfo.boomerang_id
            formattedData['package_code'] = this.packageInfo.code
            formattedData['package_type'] = this.packageInfo.package_type
            formattedData['package_client_price'] = this.packageInfo.client_price
            formattedData['package_network_code'] = this.packageInfo.network_code
            formattedData['additional_repair_cost'] = this.additional_repair_cost
            formattedData['transport_cost'] = this.transportInfo
              ? this.transportInfo.transport_cost
              : 0
            formattedData['transport_ref_code'] = this.transportInfo
              ? this.transportInfo.transporter_id
              : null
          }
        }
      } else {
        formattedData['pricing_type'] = RepairFilePricingTypeConstant.GUARANTEE
      }

      try {
        const formData = new FormData()
        formData.append('data', JSON.stringify(formattedData))
        await RepairFileService.update(this.currentRepairFile.technical_id, formData)
      } catch (error) {
        handleResponseError(error)
      }
    },
    async submit() {
      let realCode = 'C'
      if (this.customer_code !== null || this.customer_code !== '') {
        realCode = this.customer_code.toUpperCase()
      }

      const formattedData = {
        status_detail: RepairFileStatusDetailConstant.PRICING_EVALUATED,
        is_complete_update: true,
        customer_code: realCode,
        requestor_collaborator_id: $store.state.currentCollaborator.technical_id
      }

      if (!this.isInGuarantee()) {
        if (this.packageType) {
          formattedData['pricing_type'] = this.packageType

          if (this.packageType === RepairFilePricingTypeConstant.PACKAGE) {
            formattedData['package_boomerang_id'] = this.packageInfo.boomerang_id
            formattedData['package_code'] = this.packageInfo.code
            formattedData['package_type'] = this.packageInfo.package_type
            formattedData['package_client_price'] = this.packageInfo.client_price
            formattedData['package_network_code'] = this.packageInfo.network_code
            formattedData['additional_repair_cost'] = this.additional_repair_cost
            formattedData['transport_cost'] = this.transportInfo
              ? this.transportInfo.transport_cost
              : 0
            formattedData['transport_ref_code'] = this.transportInfo
              ? this.transportInfo.transporter_id
              : null
          }
        }
      } else {
        formattedData['pricing_type'] = RepairFilePricingTypeConstant.GUARANTEE
      }

      try {
        const formData = new FormData()
        formData.append('data', JSON.stringify(formattedData))
        await RepairFileService.update(this.currentRepairFile.technical_id, formData)

        this.$emit('change-step', this.currentStep + 1)
      } catch (error) {
        handleResponseError(error)
      }
    },
    setError(key) {
      switch (key) {
        case 'not_found_error_key':
          this.error = { customer_code: this.$t('ERROR.' + ResponseConstant[key]) }
          break
        default:
          this.error = ''
      }
    },
    resetError(error) {
      if (this.error) {
        delete this.error[error]
      }
    },
    openModal(modalName) {
      this.packageType = 'PACKAGE'
      // Update partial data to get repair_file.customer_code for generate pdf
      this.updatePartialData()
      this.$refs[modalName].show({
        boomerangId: this.currentRepairFile?.boomerang_id
      })
    },
    showNewPrice() {
      return (
        this.currentRepairFile.product_new_price !== null &&
        this.currentRepairFile.product_new_price > 0 &&
        this.getTotalAmount() / this.currentRepairFile.product_new_price > 0.75
      )
    }
  }
}
</script>

<style scoped>
.v-card {
  padding: 24px;
}

.v-form p {
  margin-bottom: 16px;
}

.arrow-black-svg {
  height: 100%;
  width: 50%;
  filter: invert(0%) sepia(35%) saturate(13%) hue-rotate(154deg) brightness(96%) contrast(100%);
}

.arrow-white-svg {
  height: 100%;
  width: 50%;
  filter: invert(100%) sepia(0%) saturate(1%) hue-rotate(209deg) brightness(109%) contrast(101%);
}

.boom-button-transparent:hover .arrow-svg {
  filter: invert(48%) sepia(35%) saturate(7492%) hue-rotate(64deg) brightness(105%) contrast(79%);
}

.package-info {
  text-align: center;
  border: 1px solid #559a1b;
  background-color: #efefef;
}

.package-info.active {
  color: white;
  background-color: #559a1b;
}

.package-info .v-radio {
  display: flex;
  justify-content: center;
}

.package-info p {
  margin-bottom: 5px;
}

.package-info .card-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 0;
}

.package-info .card-sub-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
}

.red-new-price {
  color: var(--error-color);
}

.send-estimate-package {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.send-white-svg {
  filter: invert(0%) sepia(35%) saturate(13%) hue-rotate(154deg) brightness(96%) contrast(100%);
}

.send-black-svg {
  filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%);
}

.customer-text {
  display: flex;
}

.tooltip-content {
  max-width: 300px;
  white-space: normal;
  color: black;
  background-color: whitesmoke;
}

:deep(.v-overlay__content) {
  background-color: whitesmoke !important;
  border: 1px solid #54981b !important;
  border-radius: 20px;
}

.align-left {
  text-align: left;
}
</style>
